import { render, staticRenderFns } from "./SchoolArea.vue?vue&type=template&id=c11541ce&scoped=true"
import script from "./SchoolArea.vue?vue&type=script&lang=js"
export * from "./SchoolArea.vue?vue&type=script&lang=js"
import style0 from "./SchoolArea.vue?vue&type=style&index=0&id=c11541ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11541ce",
  null
  
)

export default component.exports